import { Box, BoxProps, styled, Typography } from '@mui/joy';
import { ITooltipParams } from 'ag-grid-community';
import { isArray } from 'lodash';

import { warningTypeColorMap } from 'core/constants';
import { WarningType } from 'core/enums';
import { Color, Level } from 'theme/enums';

interface IProps extends ITooltipParams {
  type?: WarningType;
}

interface IWrapperProps extends BoxProps {
  color: Color;
}

const propsToSkip = ['type'];
const shouldForwardProp = (prop: string) => !propsToSkip.includes(prop);

const Wrapper = styled(Box, { shouldForwardProp })<IWrapperProps>(({ theme, color }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '2px 5px',
  alignItems: 'flex-start',
  background:
    color === Color.WARNING ? theme.palette?.[color]?.[200] : theme.palette?.[color]?.softBg,
  borderRadius: 6,
  boxShadow: '0px 2px 4px 0px rgba(21, 21, 21, 0.08), 0px 1px 2px 0px rgba(21, 21, 21, 0.08)',
  whiteSpace: 'normal',
  maxWidth: 250,
  textJustify: 'inter-word',
}));

const WarningTooltipForAgGrid = ({ value, type = null }: IProps) => {
  if (!value) {
    return <></>;
  }

  const warnings = isArray(value) ? value : [value];
  const color = type ? warningTypeColorMap[type] : Color.NEUTRAL;

  return (
    <Wrapper color={color}>
      {warnings.map((item: string, index: number) => (
        <Typography key={index} level={Level.TITLE_SM} color={color}>
          {item}
        </Typography>
      ))}
    </Wrapper>
  );
};

export default WarningTooltipForAgGrid;
